/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_TitleInputs */

const en_cargos_title = /** @type {(inputs: Cargos_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventory Cargos`)
};

const es_cargos_title = /** @type {(inputs: Cargos_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargas de inventario`)
};

/**
* | output |
* | --- |
* | "Inventory Cargos" |
*
* @param {Cargos_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_title = /** @type {((inputs?: Cargos_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_title(inputs)
	return es_cargos_title(inputs)
});